const state = {
  apiCount: 0,
  pageLoading: false
}

const getters = {
  isLoading: state => state.apiCount > 0 || state.pageLoading
}

const mutations = {
  START_API (state) {
    state.apiCount += 1
  },
  END_API (state) {
    state.apiCount = Math.max(0, state.apiCount - 1)
  },
  SET_PAGE_LOADING (state, value) {
    state.pageLoading = !!value
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations
}
